import React from 'react'
import {LoadingCard} from '../../../../../core/components/topic-card/TopicCard'
import Box from '../../../../../core/components/box/Box'
import {getBreadcrumbsFromTopic} from '../../../../../core/components/breadcrumbs/BreadCrumbs'
import Heading from '../../../../../core/components/typography/heading/Heading'
import Text from '../../../../../core/components/typography/text/Text'
// import BreadCrumbs from '../../../../../core/components/breadcrumbs/BreadCrumbs'
import Card from '../../../../../core/components/card/Card'
import SubjectToCSSName from '../../../../../core/less/SubjectToCSSName'
import map from 'lodash/map'
import replace from 'lodash/replace'
import './journeyChunk.css'

const JourneyCard = ({
  title,
  description,
  id,
  slug,
  breadcrumbTopics,
  subjectColorId,
  numProblems
}) => {
  let breadcrumbs = null
  let colorSubject = subjectColorId ? subjectColorId : id
  if (breadcrumbTopics.length) {
    breadcrumbs = `${breadcrumbTopics[0]}`
    if (breadcrumbTopics.length > 1) {
      breadcrumbs = `${breadcrumbs} > ${breadcrumbTopics[1]}`
    }
  }

  // Strip links text from links.
  description = replace(
    replace(description, /<a\b[^>]*>/gi, ''),
    /<\/a>/gi,
    ''
  )
  const headerColor = Object.prototype.hasOwnProperty.call(SubjectToCSSName, colorSubject) ? `${SubjectToCSSName[colorSubject]}-nav` : 'darkGray'
  const problemOrProblems = numProblems === 1 ? 'problem' : 'problems'
  return (
    <Card
      width="100%"
      to={slug}
      display='flex'
      direction='column'>
      <Heading
        color={headerColor}
        dangerouslySetInnerHTML={{ __html: title }}
        fontWeight='medium'
        size='md'
      />
      {
        breadcrumbTopics.length
          ? <Box
            marginBottom={2}
            display='flex'
            direction='column'
            smDirection='row'>
            <Box marginBottom={1} smMarginBottom={0}>
              <Text
                size='xs'
                color='lightGray'
                dangerouslySetInnerHTML={{ __html: breadcrumbs }}
              />
            </Box>
            <Box marginLeft={2} marginRight={2} display='none' smDisplay='block'>
              <Text size='xs'>
                  |
              </Text>
            </Box>
            <Text size='xs' fontWeight='book'>
                Practiced {numProblems} {problemOrProblems}
            </Text>
          </Box>
          : <Box
            marginBottom={2}
            display='flex'
            direction='column'
            smDirection='row'>
            <Text size='xs' fontWeight='book'>
                Practiced {numProblems} {problemOrProblems}
            </Text>
          </Box>
      }
      <div className='topiccard__description'>
        <Text
          color='darkGray'
          size='sm'
          leading='tall'
          fontWeight='book'
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </Card>
  )
}
const generateTopicCards = entries => {
  return entries.map((c, index) => {
    const topic = c.topic
    const numProblems = c.problemCount
    const breadcrumbs = getBreadcrumbsFromTopic(topic)
    const subjectColorId = breadcrumbs.length ? breadcrumbs[0].id : null
    let colorSubject = subjectColorId ? subjectColorId : topic.id
    const breadcrumbTopics = map(
      breadcrumbs,
      t => t.renderedTitle
    )
    const circleColor = Object.prototype.hasOwnProperty.call(SubjectToCSSName, colorSubject) ? `${SubjectToCSSName[colorSubject]}-nav` : 'darkGray'
    return (
      <Box display='flex' marginBottom={4} key={index}>
        <Box column={1} display='flex' flexShrink={0}>
          <div className="journey-chunk__timeline-entry">
            <div className="journey-chunk__timeline">
              <div className='journey-chunk__timeline-mask' >
                <div className="journey-chunk__timeline-circle" >
                  <Box color={circleColor} width='100%' height='100%' />
                </div>
              </div>
              {entries.length > 1 && index < entries.length - 1 ? (
                <div className="journey-chunk__timeline-line" />
              ) : (
                <div className="journey-chunk__timeline-line journey-chunk__timeline-line--inactive" />
              )}
            </div>
          </div>
        </Box>
        <Box column={11} marginLeft={6} smMarginLeft={0}>
          <div className="journey-chunk__topiccard-container">
            <JourneyCard
              title={topic.renderedTitle}
              slug={topic.slug}
              id={topic.id}
              description={topic.renderedDescription}
              breadcrumbTopics={breadcrumbTopics}
              subjectColorId={subjectColorId}
              numProblems={numProblems}
            />
          </div>
        </Box>
      </Box>
    )
  })
}

const generateLoadingTopicCards = numToGenerate => {
  const topicCards = []
  for (let i = 0; i<numToGenerate; i++) {
    topicCards.push(
      (
        <Box display='flex' marginBottom={4} key={i}>
          <Box column={1} display='flex' flexShrink={0}>
            <div className="journey-chunk__timeline-entry">
              <div className="journey-chunk__timeline">
                <div className='journey-chunk__timeline-mask' >
                  <div className="journey-chunk__timeline-circle" >
                    <Box dangerouslySetInlineStyle={{__style:{backgroundColor: 'rgba(162, 162, 162, 0.58)'}}} width='100%' height='100%' />
                  </div>
                </div>
                {numToGenerate > 1 && i < numToGenerate - 1 ? (
                  <div className="journey-chunk__timeline-line" />
                ) : (
                  <div className="journey-chunk__timeline-line journey-chunk__timeline-line--inactive" />
                )}
              </div>
            </div>
          </Box>
          <Box column={11} marginLeft={6} smMarginLeft={0}>
            <div className="journey-chunk__topiccard-container">
              <LoadingCard
                className="journey-chunk__topiccard"
                light
              />
            </div>
          </Box>
        </Box>
      )
    )
  }
  return topicCards
}

const JourneyChunk = ({ timeago, entries, loading }) => {
  if (loading) {
    const topicCards = generateLoadingTopicCards(2)
    return (
      <div className="journey-chunk">
        <Box display='flex'>
          <Box column={1} display='none' smDisplay='block' />
          <Box column={12} smColumn={11} marginBottom={4}>
            <h3 className="journey-chunk__timeago journey-chunk__timeago--loading" />
          </Box>
        </Box>
        {topicCards}
      </div>
    )
  } else {
    const topicCards = generateTopicCards(entries)
    return (
      <div className="journey-chunk">
        <Box display='flex'>
          <Box column={1} display='none' smDisplay='block' />
          <Box column={12} smColumn={11} marginBottom={4}>
            <Heading size='md' color='midGray' fontWeight='medium'>{timeago}</Heading>
          </Box>
        </Box>
        {topicCards}
      </div>
    )
  }

}

export default JourneyChunk



// WEBPACK FOOTER //
// ./src/domains/home/logged-in-home/journey/components/JourneyChunk.js